"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormTextArea = void 0;
const text_area_1 = require("../../../components/text-area/text-area");
const form_field_1 = require("./form-field");
exports.FormTextArea = form_field_1.formFieldFactory(text_area_1.TextArea);
//# sourceMappingURL=form-text-area.js.map